import { BillingCountResponse, ServiceUnitRenderResponse, dateModel,TrainingLinkDateModel ,TrainingLinksResponse,UpcomingAppointmentsDataModel,UpcomingAppointmentsResponse,UpcomingComplianceCountDataModal,UpcomingComplianceCountResponse,UpcomingComplianceDataModal,UpcomingComplianceResponse,FilterDateModel,ServiceRuleExpectedUsageModal} from "src/dataModels/dashboardResponseModel";
import { API_ENDPOINTS } from "./api-endpoints";
import { customAxios } from "./useExPressApi";
import { GenericResponse } from "src/dataModels/authSetModels";
import { TimeClockedByIdResponse, UpdateStaffTimeClockPayload } from "src/dataModels/clinicResponseModels";

export const dashboardServices = {

    clientCount: (data) => {
        let url = `${API_ENDPOINTS.GET_CLIENT_COUNT}?siteId=${data?.siteId}&startDate=${data?.startDate}&endDate=${data?.endDate}&sortBy=${data?.sortBy}&isActive=${data?.isActive}`;
    
        if (data?.dischargeReasonId != null) {
            url += `&dischargeReasonId=${data?.dischargeReasonId}`;
        }
    
        return customAxios.get<any>(url);
    },
    
    diagnosisCount: () => {
        return customAxios.get<any>(`${API_ENDPOINTS.GET_CLIENT_DIAGNOSIS_COUNT}`);
    },
    serviceUnitsRender: (data: dateModel) => {
        return customAxios.get<ServiceUnitRenderResponse>(`${API_ENDPOINTS.GET_SERVICE_UNITS_RENDER}${data?.pastYearDate}&toDate=${data?.currentDate}&siteId=${data?.siteId}`);
    },

    billingCounts: (data: dateModel) => {
        return customAxios.get<BillingCountResponse>(`${API_ENDPOINTS.GET_BILLING_COUNTS}${data?.pastYearDate}&toDate=${data?.currentDate}&siteId=${data?.siteId}`);
    },

    getStaffClockStatus: () => {
        return customAxios.get<GenericResponse>(`${API_ENDPOINTS.GET_STAFF_CLOCK_STATUS}`);
    },
    insertClockStatus: () => {
        return customAxios.post<GenericResponse>(`${API_ENDPOINTS.CREATE_NEW_TIMECLOCK}`, { "isCustomClock": false });
    },
    getTimeClockById: (id: Number) => {
        return customAxios.get<TimeClockedByIdResponse>(`${API_ENDPOINTS.GET_TIME_CLOCK_BY_ID}${id}`);
    },
    updateStaffTimeClockById: (data: UpdateStaffTimeClockPayload) => {
        return customAxios.put<any>(`${API_ENDPOINTS.UPDATE_STAFF_TIME_CLOCK}`, data);
    },
    clientByGenderCount: (data) => {
        let url = `${API_ENDPOINTS.GET_CLIENT_BY_GENDER_COUNT}?siteId=${data?.siteId}&startDate=${data?.startDate}&endDate=${data?.endDate}&sortBy=${data?.sortBy}&isActive=${data?.isActive}`;
    
        if (data?.dischargeReasonId != null) {
            url += `&dischargeReasonId=${data?.dischargeReasonId}`;
        }
    
        return customAxios.get<any>(url);
    },
    getTimeClockArchiveById: (staffTimeClockId: Number) => {
        return customAxios.get<any>(`${API_ENDPOINTS.GET_TIME_CLOCK_ARCHIVE_BY_ID}?staffTimeClockId=${staffTimeClockId}`)
    },

    getTrainingLinks : (params:TrainingLinkDateModel) =>{
        return customAxios.get<TrainingLinksResponse>(`${API_ENDPOINTS.GET_TRAINING_LINKS}?startDate=${params?.startDate}&endDate=${params?.endDate}`) 
    },
    getDaysSinceLastSeenExcel : (data:any) =>{
        return customAxios.post<any>(`${API_ENDPOINTS.DAYS_SINCE_CLIENTS_LAST_SEEN_EXCEL}`, data);
    },
    expiringAuthorizationsExcel : (data:any) =>{
        return customAxios.post<any>(`${API_ENDPOINTS.EXPIRING_AUTHORIZATIONS_EXCEL}`,data) 
    },
    getUpcomingAppointments : (params:UpcomingAppointmentsDataModel) =>{
        return customAxios.get<UpcomingAppointmentsResponse>(`${API_ENDPOINTS.GET_UPCOMING_APPOINTMENTS}?startDate=${params?.startDate}&endDate=${params?.endDate}`) 
    },
    getDischargeReasons : () =>{
        return customAxios.get<GenericResponse>(`${API_ENDPOINTS.GET_DISCHARGE_REASON}`) 
    },
    getUpcomingComplianceCount : (params:UpcomingComplianceCountDataModal[]) =>{
        return customAxios.post<any , UpcomingComplianceCountResponse>(`${API_ENDPOINTS.GET_UPCOMING_COMPLIANCE_COUNT}`, params);
    },
    getUpcomingCompliance : (params:UpcomingComplianceDataModal) =>{
        return customAxios.post<any , UpcomingComplianceResponse>(`${API_ENDPOINTS.GET_UPCOMING_COMPLIANCE}`, params);
    },
    getInsuranceTypes: () => {
        return customAxios.get<any>(`${API_ENDPOINTS.GET_INSURANCE_TYPE}`);
    },
    updateCustomRole: (params: any) => {
        return customAxios.post<any>(`${API_ENDPOINTS.UPDATE_CUSTOM_ROLE_NAME}`, params);
    },
    getCurrentTasks: (data: any) => {
        return customAxios.post<any>(`${API_ENDPOINTS.GET_ALL_TASKS_BY_SEARCH}`, data);
    },
    updateTaskStatusValue: (data: any) => {
        return customAxios.put<any>(`${API_ENDPOINTS.UPDATE_TASK_STATUS}`, data);
    },
    getAnnouncements: (data: boolean) => {
        return customAxios.post<any>(`${API_ENDPOINTS.GET_ANNOUNCEMENTS}`, data);
    },
    getAnnouncementsById: (id: number) => {
        return customAxios.get<any>(`${API_ENDPOINTS.GET_ANNOUNCEMENTS_BY_ID}${id}`);
    },
    saveAnnouncementsList: (data: any) => {
        return customAxios.post<any>(`${API_ENDPOINTS.SAVE_ANNOUNCEMENTS_LIST}`, data);
    },
    updateAnnouncementsList: (data: any) => {
        return customAxios.post<any>(`${API_ENDPOINTS.UPDATE_ANNOUNCEMENTS_LIST}`, data);
    },
    deleteAnnouncements: (id: number) => {
        return customAxios.delete<any>(`${API_ENDPOINTS.DELETE_ANNOUNCEMENTS}${id}`);
    },
    getServiceRuleExpectedUsage: (serviceDate: string) => {
        return customAxios.get<ServiceRuleExpectedUsageModal>(`${API_ENDPOINTS.GET_SERVICE_RULE_EXPECTED_USAGE}?serviceDate=${serviceDate}`);
    },
}